/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Getting_TranscriptsInputs */

const en_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error getting transcripts`)
};

const fr_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erreur lors de la récupération des transcriptions`)
};

const de_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehler beim Abrufen der Transkripte`)
};

const it_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errore durante il recupero delle trascrizioni`)
};

const ru_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ошибка при получении стенограмм.`)
};

const es_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Error al obtener las transcripciones`)
};

const zh_cn2_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`获取成绩单时出错`)
};

const ja_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`トランスクリプトの取得中にエラーが発生しました`)
};

const hi_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`प्रतिलेख प्राप्त करने में त्रुटि`)
};

const pt_pt2_error_getting_transcripts = /** @type {(inputs: Error_Getting_TranscriptsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erro ao obter transcrições`)
};

/**
* | output |
* | --- |
* | "Error getting transcripts" |
*
* @param {Error_Getting_TranscriptsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_getting_transcripts = /** @type {((inputs?: Error_Getting_TranscriptsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Getting_TranscriptsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_error_getting_transcripts(inputs)
	if (locale === "de") return de_error_getting_transcripts(inputs)
	if (locale === "it") return it_error_getting_transcripts(inputs)
	if (locale === "ru") return ru_error_getting_transcripts(inputs)
	if (locale === "es") return es_error_getting_transcripts(inputs)
	if (locale === "zh-CN") return zh_cn2_error_getting_transcripts(inputs)
	if (locale === "ja") return ja_error_getting_transcripts(inputs)
	if (locale === "hi") return hi_error_getting_transcripts(inputs)
	if (locale === "pt-PT") return pt_pt2_error_getting_transcripts(inputs)
	return en_error_getting_transcripts(inputs)
});